export function isImpersonatingPartner() {
    return !!localStorage.getItem('MFPP.Auth.Actor');
}

export function stopImpersonatingPartner() {
    localStorage.setItem('MFPP.Auth', localStorage.getItem('MFPP.Auth.Actor'));
    localStorage.removeItem('MFPP.Auth.Actor');
}

export function impersonatePartner(token) {
    localStorage.setItem('MFPP.Auth.Actor', localStorage.getItem('MFPP.Auth'));
    localStorage.setItem('MFPP.Auth', JSON.stringify(token));
}
